<template>
    <div>
        <v-row dense>
            <v-col cols="12">
                <v-card
                    outlined
                    class="pa-4"
                >
                    <v-form ref="form">
                        <v-row dense>
                            <v-col cols="12" xs="6" sm="6" md="3" lg="3" xl="3">
                                <v-text-field
                                    v-model="localItem.codigo"
                                    :rules="[rules.required]"
                                    outlined
                                    dense
                                    required
                                    :class="$css_field"
                                    hide-details
                                    @keydown.enter="validate"
                                >
                                    <template v-slot:label>
                                        <span :class="$css_field">Código</span>
                                    </template>
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" xs="6" sm="6" md="2" lg="2" xl="2">
                                <v-btn
                                    color="primary"
                                    @click="validate"
                                    :class="$css_button"
                                >
                                    Adicionar
                                </v-btn>
                            </v-col>    
                        </v-row>    
                    </v-form>
                </v-card>
            </v-col>
        </v-row>

        <v-row dense v-if="properties && properties.length > 0">
            <v-col cols="12" :md="$vuetify.breakpoint.lgAndUp ? 3 : 4" v-for="shop in properties" :key="shop.id">
                <card-property-vertical :item="shop" @callDeleteItem="deleteItem" />
            </v-col>
        </v-row>
    </div>
</template>


<script>
import CardPropertyVertical from './CardPropertyVertical.vue'

export default {
    components: {
        CardPropertyVertical
    },

    props: {
        property_relations: {
            type: Array, // Adicione o tipo
            required: true, // Corrigido: "required" em vez de "require"
            default: () => {} // Adicione um valor padrão para arrays
        },

        item_id: {
            type: String, // Adicione o tipo
            required: true, // Corrigido: "required" em vez de "require"
            default: () => {} // Adicione um valor padrão para arrays
        },
    },

    watch: {
        property_relations: {
            handler(newVal) {
               this.setObject()
            },
            deep: true, // Observa mudanças profundas
            immediate: true // Executa imediatamente ao montar
        },

        item_id: {
            handler(newVal) {
               this.setObject()
            },
            deep: true, // Observa mudanças profundas
            immediate: true // Executa imediatamente ao montar
        }
    },

    mounted() {
        this.setObject()
    },

    data () {
        return {
            localItem: {
                model: 'shopwindow',
                item_id: null,
                codigo: null
            },

            properties: [],

            rules: {
                required: value => !!value || 'Campo obrigatório.',
            },
        }
    },

    methods: {
        setObject() {
            this.properties = this.property_relations;
            this.localItem.item_id = this.item_id;
        },

        validate(){
            if (this.$refs.form.validate()) {       
                this.store()
            }
        },

        store(){
            const index = this.properties.findIndex(c => c.codigo === this.localItem.codigo);
            if(index == -1){
                this.$store.dispatch('storePropertyRelation', this.localItem)
                            .then(response => {
                                const result = response.data
                                this.properties.push(result);
                                this.reset()
                            })
                            .catch(error => {   
                                this.$snotify.error('Erro no cadastro');
                            });
            } else {
                this.$snotify.error('O codigo '+ this.localItem.codigo +' já foi adicionado.');
            }                      
        },

        reset(){
            this.localItem.codigo = null;
            this.$refs.form.reset()
        },

        deleteItem(id){
            this.$store.dispatch('destroyPropertyRelation', id)
                        .then(response => {
                            // Encontra o índice do colaborador no array
                            const index = this.properties.findIndex(c => c.property_relation_id === id);
                            this.properties.splice(index, 1);
                        })
                        .catch(error => {
                            this.$snotify.error('Erro no cadastro');
                        })
                        .finally(
                            //this.$snotify.remove()
                            this.$snotify.success('Registro excluído com sucesso!')
                        )
        }
        
    }   
}
</script>